let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2nEVn")).then(() => parcelRequire('85UpT'));